import React, {useState} from 'react';
import classes from './Registration.module.scss';
import {useForm} from "react-hook-form";
import {patientService} from "../../../../api/patientServices";
import RegistrationForm from "../RegistrationForm";
import errorMessage from "../../../../const/Tost";
import {toast} from "react-toastify";

const FindPatientForm = () => {
    const {register, handleSubmit, reset, setValue} = useForm();
    const [phoneNumber, setPhoneNumber] = useState('+380 (');
    const [searchMethod, setSearchMethod] = useState('phone'); // 'phone' or 'card'
    const [data, setData] = useState(null);
    const [patientId, setPatientId] = useState(null);
    const [isCopied, setIsCopied] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    const handlePhoneChange = (e) => {
        const input = e.target.value;
        const cleaned = input.replace(/\D/g, '');
        if (!cleaned.startsWith('380')){
            setPhoneNumber('+380 (');
            return;
        }

        let formattedNumber = '+380 (';
        if (cleaned.length > 3) formattedNumber += cleaned.slice(3, 5);
        if (cleaned.length >= 6) formattedNumber += ') ' + cleaned.slice(5, 8);
        if (cleaned.length >= 9) formattedNumber += ' ' + cleaned.slice(8, 10);
        if (cleaned.length >= 11) formattedNumber += ' ' + cleaned.slice(10, 12);

        setPhoneNumber(formattedNumber);
    };

    const onSubmit = async(formData) => {
        if (searchMethod === 'phone'){
            const phoneNum = phoneNumber.replace(/[\+\s\(\)]/g, '');
            if (phoneNum.length < 12){
                errorMessage('', 'Короткий номер телефону');
                return;
            }

            const res = await patientService.FindPatientByParam('phoneNumber=' + phoneNum);
            const patient = res?.data?.data?.[0];

            if (patient?.outside){
                toast.error('Створіть нового пацієнта, цей паціент зовнішній')
            } else if (patient){
                delete patient.birthDate;
                setPatientId({id: patient.id});
                setData({...patient, outside: false});
            } else {
                setData({phoneNumber: phoneNum, outside: false});
            }

        } else if (searchMethod === 'card'){
            const cardNum = formData.cardNumber?.trim();
            if (!cardNum){
                errorMessage('', 'Введіть номер карти');
                return;
            }

            const res = await patientService.FindPatientByParam('cardNumber=' + cardNum);
            const patient = res?.data?.data?.[0];
            if (patient?.outside){
                toast.error('Створіть нового пацієнта, цей паціент зовнішній')
            } else if (patient){
                delete patient.birthDate;
                setPatientId({id: patient.id});
                setData({...patient, outside: false});
            } else {
                toast.error('Пацієнта з такою картою не знайдено!')
            }
        }
    };

    const pasteHandler = () => {
        const data = JSON.parse(localStorage.getItem('PatientData'));
        if (data?.id){
            setPatientId(data.id);
            delete data.phoneNumber;
            setData((prev) => ({...data, outside: prev?.outside}));
            setIsCopied(true);
        } else {
            errorMessage('Copy error', 'Немає скопійованих даних про пацієнта');
        }
    };

    return (
        <>
            {/* Перше питання: новий пацієнт? */}
            <div className={classes.form} style={!activeTab ? {display: 'flex'} : {display: 'none'}}>
                <label className={classes.form__label}>Новий пацієнт?</label>
                <div className={classes.form__question_btn}>
                    <button className={classes.form__button} onClick={() => {
                        setData({phoneNumber: false, outside: true});
                        setActiveTab(1);
                    }}>Так
                    </button>
                    <button className={classes.form__button} onClick={() => setActiveTab(2)}>Ні</button>
                </div>
            </div>

            {/* Якщо пацієнт не новий — форма пошуку */}
            {!data && activeTab === 2 && (
                <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                    <label className={classes.form__label}>Оберіть тип пошуку</label>
                    <div className={classes.form__radioGroup}>
                        <label className={classes.form__radio}>
                            <input
                                type="radio"
                                value="phone"
                                checked={searchMethod === 'phone'}
                                onChange={() => {
                                    setSearchMethod('phone');
                                    reset(); // Скинути форму
                                    setPhoneNumber('+380 (');
                                }}
                            />
                            За номером телефону
                        </label>
                        <label className={classes.form__radio}>
                            <input
                                type="radio"
                                value="card"
                                checked={searchMethod === 'card'}
                                onChange={() => {
                                    setSearchMethod('card');
                                    reset(); // Скинути форму
                                }}
                            />
                            За номером карти
                        </label>
                    </div>

                    {searchMethod === 'phone' && (
                        <>
                            <label className={classes.form__label}>Введіть номер телефону пацієнта</label>
                            <input
                                type="text"
                                className={classes.form__input}
                                placeholder="+380 (XX) XXX XX XX"
                                maxLength={19}
                                value={phoneNumber}
                                onChange={handlePhoneChange}
                                onFocus={() => setPhoneNumber('+380 (')}
                            />
                        </>
                    )}

                    {searchMethod === 'card' && (
                        <>
                            <label className={classes.form__label}>Введіть номер карти пацієнта</label>
                            <input
                                type="text"
                                className={classes.form__input}
                                placeholder="Номер карти"
                                {...register('cardNumber')}
                            />
                        </>
                    )}

                    <button className={classes.form__button} type="submit">Продовжити</button>
                </form>
            )}

            {data && (
                <RegistrationForm
                    patientInfo={data}
                    patientId={patientId?.id}
                    pasteHandler={pasteHandler}
                    isCopied={isCopied}
                    outside={data?.outside}
                />
            )}
        </>
    );
};

export default FindPatientForm;
